/* eslint-disable comma-dangle, space-in-parens */
// Comma dangle was screwing up the lazy import
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import constants from 'utils/constants';

const TransferWorkflow = React.lazy(() =>
  import(
    /* webpackChunkName: 'modifyTransfer' */
    '../../../components/modifyTransfer/ModifyTransfer'
  )
);

export default function TransfersRoutes() {
  return (
    <Switch>
      <Route
        path={`${constants.WORKFLOWS.TRANSFER}/:type/:action/:id`}
        component={TransferWorkflow}
      />
    </Switch>
  );
}
